import { Stack } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Navigator } from '../../../components/Navigator';
import { PageLayout } from '../../../layout';
import { ScheduledActionPageHeader } from './modules/ScheduledActionPageHeader';
import { ScheduledActionControl } from './modules/SheduledActionControl';
import { TaskIdCustomerInfoBox } from './modules/TaskIdCustomerInfoBox';
import { TaskIdInvoiceOrClaimInfoBox } from './modules/TaskIdInvoiceOrClaimInfoBox';
import { TaskIdRemindingToneBox } from './modules/TaskIdRemindingToneBox';
import { TaskIdScheduledActionsBox } from './modules/TaskIdScheduledActionsBox';

const TRANS_NS = 'page-admin-task-detail';

export const ScheduledActionDetail = () => {
  const { t } = useTranslation(TRANS_NS);
  const { taskId } = useParams();

  const navLinks = [
    {
      href: '#scheduledAction',
      label: t('task'),
    },
    {
      href: '#customer',
      label: t('customer'),
    },
    {
      href: '#invoice',
      label: t('invoiceInfo'),
    },
    {
      href: '#scheduledActions',
      label: t('scheduledActions.all'),
    },
  ];

  return (
    <PageLayout>
      {taskId ? <ScheduledActionPageHeader taskId={taskId} /> : null}

      <Grid2 mt={4} container spacing={2}>
        <Grid2 xs={12} md={10}>
          <Stack gap={4}>
            {taskId ? <ScheduledActionControl taskId={taskId} id={'scheduledAction'} /> : null}
            {taskId ? <TaskIdCustomerInfoBox taskId={taskId} id={'customer'} /> : null}
            {taskId ? <TaskIdInvoiceOrClaimInfoBox taskId={taskId} id={'invoice'} /> : null}
            {taskId ? <TaskIdScheduledActionsBox taskId={taskId} id={'scheduledActions'} /> : null}
          </Stack>
        </Grid2>
        <Grid2 xs={12} md={2}>
          <Stack gap={4} sx={{ position: 'sticky', top: 20, minWidth: 200 }}>
            {taskId ? <TaskIdRemindingToneBox taskId={taskId} /> : null}
            <Navigator navLinks={navLinks} />
          </Stack>
        </Grid2>
      </Grid2>
    </PageLayout>
  );
};
